import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IB2BDocument } from "../b2bDocumentModel";

export const getAllB2BDocument = createAsyncThunk(
  "DocumentUpload/FindAllDocumentUpload",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/DocumentUpload/FindAllDocumentUpload`,
        {
          Title: "",
        },
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Document:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createB2BDocument = createAsyncThunk(
  "DocumentUpload/InsertDocumentUpload",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/DocumentUpload/InsertDocumentUpload`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Document:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateB2BDocument = createAsyncThunk(
  "DocumentUpload/UpdateDocumentUpload",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/DocumentUpload/UpdateDocumentUpload`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating document:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteB2BDocument = createAsyncThunk(
  "DocumentUpload/DeleteDocumentUpload",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/DocumentUpload/DeleteDocumentUpload`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting document:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getB2BDocumentByID = createAsyncThunk(
  "DocumentUpload/FindByIDDocumentUpload",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/DocumentUpload/FindByIDDocumentUpload`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Title: result.Title,
        Remarks: result.Remarks,
        Image: result.Image,
        IsActive: result.IsActive === true ? 1 : 2,
      } as IB2BDocument;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Document:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveB2BDocument = createAsyncThunk(
  "DocumentUpload/FindAllActiveDocumentUpload",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/DocumentUpload/FindAllActiveDocumentUpload`,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Document:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const ActiveInactiveB2BDocument = createAsyncThunk(
  "DocumentUpload/ActiveInActiveDocumentUpload",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/DocumentUpload/ActiveInActiveDocumentUpload`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Document:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
